function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M6 7c-2 0-3 1-3 3v5c0 2 1 3 3 3l2-2v-1h1l8-8H6zm1 4.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 15l-1 1v-1h1zm8-10v2H7V5c0-1.66 1.34-3 3-3h4c1.66 0 3 1.34 3 3z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.53 1.47a.75.75 0 010 1.06l-20 20a.75.75 0 01-1.06-1.06l20-20a.75.75 0 011.06 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.75 11c0 .41-.34.75-.75.75H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75zm8 4c0 .41-.34.75-.75.75h-5.75l1.5-1.5H17c.41 0 .75.34.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 15v4c0 1.66-1.34 3-3 3h-2c-1.66 0-3-1.34-3-3l4-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 10v5c0 2-1 3-3 3h-2v-3h-4l7.67-7.67C20.56 7.78 21 8.67 21 10z"
})));